/* HotDawgs — shared site behavior
   Newsletter signup now runs through Shopify's native customer form
   (see sections/newsletter.liquid) instead of a hand-rolled Storefront
   API call, so there's nothing to wire up for it here. */

document.addEventListener('DOMContentLoaded', () => {
  // Announcement bar — dismiss and remember for the session
  const announceBar = document.querySelector('.announce-bar');
  const announceClose = document.getElementById('announce-close');
  if (announceBar && sessionStorage.getItem('hd_announce_dismissed') === '1') {
    document.body.classList.add('announce-dismissed');
  }
  announceClose?.addEventListener('click', () => {
    document.body.classList.add('announce-dismissed');
    sessionStorage.setItem('hd_announce_dismissed', '1');
  });

  // Mobile nav toggle
  const toggle = document.querySelector('.nav-toggle');
  const links = document.querySelector('.nav-links');
  if (toggle && links) {
    toggle.addEventListener('click', () => {
      const open = links.style.display === 'flex';
      links.style.display = open ? 'none' : 'flex';
      links.style.flexDirection = 'column';
      links.style.position = 'fixed';
      links.style.top = 'var(--header-offset)';
      links.style.left = '0';
      links.style.right = '0';
      links.style.background = 'var(--cream)';
      links.style.padding = '20px 24px';
      links.style.borderBottom = '1px solid var(--line)';
    });
  }

  // GSAP scroll reveals
  if (window.gsap && window.ScrollTrigger) {
    gsap.registerPlugin(ScrollTrigger);
    document.querySelectorAll('[data-reveal]').forEach((el) => {
      gsap.fromTo(
        el,
        { opacity: 0, y: 34 },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: 'power2.out',
          scrollTrigger: { trigger: el, start: 'top 85%' },
        }
      );
    });

    document.querySelectorAll('[data-reveal-group]').forEach((group) => {
      const items = group.querySelectorAll('[data-reveal-item]');
      gsap.fromTo(
        items,
        { opacity: 0, y: 28 },
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          stagger: 0.12,
          ease: 'power2.out',
          scrollTrigger: { trigger: group, start: 'top 85%' },
        }
      );
    });

    // Hero scroll cue fade
    gsap.to('.hero-scroll-cue', {
      opacity: 0,
      scrollTrigger: { trigger: '.hero', start: 'top top', end: '60% top', scrub: true },
    });
  }
});
